<template lang="pug">
  .introVideo
    video(ref="video" src="static/media/rolik_s_nastupaushim.mp4" autoplay muted controls playsinline)
    .closer(@click="close")
</template>

<script>
export default {
  name: "IntroVideo",
  methods: {
    close() {
      this.$emit('close');
      window.sessionStorage.setItem('introVideoShowed', 1);
    }
  },
  beforeMount() {
    this.$store.commit('pageHidden');
  },
  beforeDestroy() {
    this.$store.commit('pageDelHidden');
  },
  mounted() {
    this.$refs.video.addEventListener('ended', this.close);
  }
}
</script>

<style scoped lang="scss">
.introVideo {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .closer {
    position: absolute;
    top: 1.75rem;
    right: 1.65rem;
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;

    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 0.25rem;
      border-radius: 1rem;
      background: #fff;
    }

    &:before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
  @include mobile_or_P {
    .closer {
      top: 12vmin;
      right: 6vmin;
      width: 8vmin;
      height: 8vmin;
    }
  }
}

</style>